import type { IconGlyph } from '@sunwebgroup/ui-components/uds'

export interface CheckoutServiceBanner {
  title?: string
  text?: string
  type: string
}

export type BannerType = 'info' | 'warning' | 'error' | 'success'

export interface CheckoutServiceParticipant {
  id: string
  name: string
  selectedValue: string | null
  selectedId?: string | null
  availableOptions: string[]
  birthdate: string | null
  ageCategory: CheckoutParticipantAgeCategory
}

export interface CheckoutServiceFeature {
  code: string
  icon: IconGlyph | null
  description: string
  extraContent?: {
    linkText: string
  }
}

export interface CheckoutServiceOption {
  label: string
  badge?: string
  value: string
  price: number
  rawPrice?: number
  percentage?: string
  percentageText?: string
  priceBreakdown?: {
    ageCategory: CheckoutParticipantAgeCategory
    price: number
  }[]
  features?: string[]
  modalInformation?: {
    title: string
    body: string
  }
}

export type CheckoutParticipantAgeCategory = 'Adult' | 'Child' | 'Baby'

export interface CheckoutServiceRoom {
  id: string
  name: string
  participantIds: string[]
  selectedValue?: string
  availableOptions?: string[]
}

export const bannerColorMap = {
  info: 'secondary',
  warning: 'warning',
  error: 'danger',
  success: 'success',
}
